import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input, Label} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {
  changeWtsCourseStatusSelected,
  createWtsCoursesStatus,
  updateWtsCoursesStatus,
} = Actions;

const WtsCourseStatusModal = ({mode, courseStatusToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const courseStatusSelected = useSelector((state) => state.wtsCoursesStatus.courseStatusSelected);
  const wtsCoursesStatusList = useSelector((state) => state.wtsCoursesStatus.list || []);

  const isCodeTaken = (code) => {
    if (mode === 'edit') {
      return false;
    }
    return wtsCoursesStatusList.some((item) => String(item.code).toUpperCase() === String(code).toUpperCase());
  };

  const validateValue = (key, value) => {
    switch (key) {
      case 'code':
        if (value.length > 1) {
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  const onChangeValues = (key, value) => {
    if (validateValue(key, value)) {
      const changedValue = key === 'secuencia' ? value : value.toUpperCase();
      const changedCourseStatusSelected = {...courseStatusSelected, [key]: changedValue};
      dispatch(changeWtsCourseStatusSelected(changedCourseStatusSelected));
    }
  };

  const showCourseStatusModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (mode === 'edit') {
      dispatch(changeWtsCourseStatusSelected(courseStatusToEdit));
    } else {
      dispatch(changeWtsCourseStatusSelected({'code': '', 'course_status': '', 'secuencia': '', 'status': 'A'}));
    }
  };

  const saveStatusModal = (e) => {
    e.preventDefault();
    if (mode === 'new' && isCodeTaken(courseStatusSelected?.code)) {
      return;
    }
    if (mode === 'new') {
      dispatch(createWtsCoursesStatus({'data': courseStatusSelected}));
    } else {
      dispatch(updateWtsCoursesStatus({'data': courseStatusSelected}));
    }
    showCourseStatusModal(e, false);
  };

  const renderCodeMessage = () => {
    if (mode !== 'new' || !courseStatusSelected?.code) {
      return null;
    }
    if (isCodeTaken(courseStatusSelected.code)) {
      return (
        <Label basic color='red' pointing>
          El código ya existe
        </Label>
      );
    }
    return (
      <Label basic color='green' pointing>
        Código disponible
      </Label>
    );
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showCourseStatusModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showCourseStatusModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear estado de cursos' : 'Editar estado de cursos'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showCourseStatusModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Código"
                error={mode === 'new' && isCodeTaken(courseStatusSelected?.code)}
                value={courseStatusSelected?.code || ''}
                disabled={mode !== 'new'}
                onChange={(e, {value}) => onChangeValues('code', value)}
              />
              {renderCodeMessage()}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Descripción"
                value={courseStatusSelected?.course_status || ''}
                onChange={(e, {value}) => onChangeValues('course_status', value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Secuencia"
                type="number"
                value={courseStatusSelected?.secuencia || ''}
                onChange={(e, {value}) => onChangeValues('secuencia', value)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          compact
          icon='save'
          disabled={mode === 'new' && isCodeTaken(courseStatusSelected?.code)}
          onClick={(e) => saveStatusModal(e)}
        >
          Guardar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsCourseStatusModal;
